let load = require('./helpers/browser/esm-js-loader');
module.exports = (load("fv1N2")).then(() => parcelRequire('257oE'));